module.exports = __webpack_public_path__ + "assets/img/badge_hotsale.781527b1.svg";